import { createSvgIcon } from "@mui/material";

export const ParticipantListIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path d="M16.875 5.625H3.125H2.5M3.125 10H16.875M3.125 14.375H16.875M2.5 5.625C2.5 4.58947 3.33947 3.75 4.375 3.75H15.625C16.6605 3.75 17.5 4.58947 17.5 5.625V14.375C17.5 15.4105 16.6605 16.25 15.625 16.25H4.375C3.33947 16.25 2.5 15.4105 2.5 14.375V5.625Z" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'ParticipantListIcon'
)
